/**
 * @description 繳費狀態 (enum)
 */
export enum PaymentStatusEnum {
  /** 未繳費 */
  Unpaid = '00',
  /** 繳費失敗 */
  Fail = '21',
  /** 條碼繳費中 */
  Barcode = '22',
  /** 已繳費 */
  Paid = '23',
  /** 可退費 */
  Refundable = '24',
  /** 已退費 */
  Refunded = '25'
}
